'use client'

import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { createToastActions, defaultValues, type ToastStore } from './toast'

export const useToastStore = create<ToastStore>()(
  devtools(
    (set, get) => ({
      ...defaultValues,
      ...createToastActions(set, get),
    }),
    { name: 'ToastStore', enabled: process.env.NODE_ENV === 'development' }
  )
)
